import { useEffect, useRef } from "react"

const TabSwitchWarningModal = ({ isOpen, count, onDismiss }) => {
  const audioCtx = useRef(null)

  useEffect(() => {
    if (!isOpen) return

    // Play a short alert beep
    audioCtx.current = new (window.AudioContext || window.webkitAudioContext)()
    const oscillator = audioCtx.current.createOscillator()
    const gainNode = audioCtx.current.createGain()

    oscillator.connect(gainNode)
    gainNode.connect(audioCtx.current.destination)

    oscillator.type = "sine"
    oscillator.frequency.setValueAtTime(880, audioCtx.current.currentTime)
    oscillator.frequency.exponentialRampToValueAtTime(
      440,
      audioCtx.current.currentTime + 0.3,
    )
    gainNode.gain.setValueAtTime(0.3, audioCtx.current.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(
      0.001,
      audioCtx.current.currentTime + 0.4,
    )

    oscillator.start()
    oscillator.stop(audioCtx.current.currentTime + 0.4)

    return () => {
      try {
        audioCtx.current?.close()
      } catch (_) {}
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(0,0,0,0.45)", backdropFilter: "blur(4px)" }}
    >
      <div
        className="bg-white mx-4"
        style={{
          borderRadius: 0,
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
          fontFamily: "'IBM Plex Sans', sans-serif",
        }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 px-6 py-4 border-b border-zinc-200">
          <div
            className="w-8 h-8 bg-red-50 border border-red-200 flex items-center justify-center shrink-0"
            style={{ borderRadius: 0 }}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M8 2L14 13H2L8 2Z"
                stroke="#ef4444"
                strokeWidth="1.5"
                fill="none"
                strokeLinejoin="round"
              />
              <path
                d="M8 6V9"
                stroke="#ef4444"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <circle cx="8" cy="11" r="0.75" fill="#ef4444" />
            </svg>
          </div>
          <p className="text-sm font-bold text-zinc-900 tracking-tight">
            Tab Switch Detected
          </p>
          <div
            className="ml-auto px-2 py-0.5 bg-red-50 border border-red-200"
            style={{ borderRadius: 0 }}
          >
            <span
              className="text-xs font-bold text-red-600 tabular-nums"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              {count} {count === 1 ? "violation" : "violations"}
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-sm text-zinc-700 leading-relaxed mb-1">
            You have switched away from this interview tab.
          </p>
          <p className="text-xs text-zinc-400 leading-relaxed">
            This activity is being recorded. Multiple violations may result in
            disqualification of your interview.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 pb-5">
          <button
            onClick={onDismiss}
            className="w-full bg-zinc-900 hover:bg-zinc-700 text-white text-xs font-bold uppercase tracking-widest py-3 transition-colors"
            style={{ borderRadius: 0 }}
          >
            Return to Interview
          </button>
        </div>
      </div>
    </div>
  )
}

export default TabSwitchWarningModal
